import { h, Component } from "preact";
import * as _ from "../components/index.js";
import rulesData from "../data/rules.json";

export default class Rules extends Component {
  render() {
    return (
      <>
        <_.Header title="Правила" backurl="/" />
        <section class="menu">
          {rulesData.sections.map((s) => (
            <a class="favorite_item" href={`/rules/${s.id}`}>
              <span>{s.title}</span>
            </a>
          ))}
        </section>
      </>
    );
  }
}
